import React from "react";
import View from "../../pages/login";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  login = (email, password) => {
    this.props.loginUser(email, password).then(() => {
      if (this.props.session) {
        this.props.history.push("/profile");
      }
    });
  };
  setRedirect = () => {
    this.setState({
      redirect: true,
    });
  };

  render() {
    const { redirect } = this.state;
    return (
      <View
        loginUser={this.login}
        redirect={redirect}
        setRedirect={this.setRedirect}
      />
    );
  }
}
export default Login;
